export function extractUnits(token) {
  return (
    token.units || {
      base: 0,
      [token.ticker]: token.decimals,
    }
  )
}
